import { IUser } from "../types/user";

export const initialState: IUser = {
  name: "Андрей",
  lastName: "",
  id: 0,
  age: 0,
};
